export var AgentTypeEnum;
(function (AgentTypeEnum) {
    AgentTypeEnum["CUSTOMER"] = "CUSTOMER";
    AgentTypeEnum["PLATFORM"] = "PLATFORM";
    AgentTypeEnum["EMPLOYEE"] = "EMPLOYEE";
    AgentTypeEnum["ADMIN"] = "ADMIN";
    AgentTypeEnum["SWAPPER"] = "SWAPPER";
})(AgentTypeEnum || (AgentTypeEnum = {}));
//# sourceMappingURL=agent-type.enum.js.map